import styles from "./home-tooling.style.module.scss";
server {
  const EXAMPLE_HTML = `<div/$el>
  Hop in, we've got tags
</div>

<script>
  $el().
</script>`;
  const EXAMPLE_CONCISE = `div/$el -- Hop in, we've got tags
script -- $el().
`;
}

section class=styles.section
  div class=styles.content
    h2
      span class=styles.headingText -- Types & Tooling
    p
      -- Marko has built-in${" "}
      a href="/docs/reference/typescript" -- TypeScript support
      --
      , with strong type inference that works across templates and components.
      Editors get full language features like autocompletion,
      jump-to-definition, syntax highlighting, and clean formatting.
      --
    p -- Build confidently. Catch errors early. Write better code, faster.
    home-cta-button href="/docs/introduction/integrations" -- Explore

  figure
    ,role="img"
    ,aria-label="An example showing intellisense information displayed while viewing a Marko file in a text editor."
    ,class=styles.demo
    div class=styles.example
      div class=styles.menuBar
        div class=styles.menuBarRed
        div class=styles.menuBarYellow
        div class=styles.menuBarGreen
      app-code-block
        ,theme="dark"
        ,lang="marko"
        ,text=EXAMPLE_HTML
        ,markoAlts=[EXAMPLE_CONCISE, EXAMPLE_HTML, EXAMPLE_CONCISE]
        ,cursor={
          test: /\$el\(\)\./g,
          content(h) {
            return h("ul", { class: "code-cursor-menu" }, [
              h("li", "addEventListener"),
              h("li", "animate"),
              h("li", "append"),
              h("li", "appendChild"),
              h("li", "focus"),
            ]);
          },
        }
        ,popovers=[
          {
            test: /\$el/g,
            content: (_, code) =>
              code("typescript", "const $el: () => HTMLDivElement"),
          },
          {
            test: /(?<!\/)div\b/g,
            content: (h) => [
              "Built in HTML ",
              h(
                "a",
                {
                  href: "https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/div",
                },
                "<div>",
              ),
              " tag.",
            ],
          },
          {
            test: /(?<!\/)script\b/g,
            content: (h) => [
              "Built in core ",
              h(
                "a",
                {
                  href: "/docs/reference/core-tag#script",
                },
                "<script>",
              ),
              " tag.",
            ],
          },
        ]
